module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C600"
  }, [_c('em', [_c('span', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("Figures ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C612"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_Socrat#page_26"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("1")]), _vm._v("Jacques-Louis David, "), _c('em', [_vm._v("The Death of Socrates")]), _vm._v(", 1787 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C609"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_Socrat#page_42"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("2")]), _vm._v("Frontispiece image of Mendelssohn and Socrates, from J. Heinemann, "), _c('em', [_vm._v("Moses Mendelssohn. Sammlung theils noch ungedruckter, theils andern Schriften zerstreuter Aufsätze und Briefe von ihm, an und über ihn")]), _vm._v(", Leipzig 1831 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C609"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_Socrat#id_239"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("3")]), _vm._v("Frontispiece, Moses Mendelssohn, "), _c('em', [_vm._v("Phaedon oder über die Unsterblichkeit der Seele in drei Gesprächen")]), _vm._v(", Berlin 1767 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C609"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_Socrat#id_241"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("4")]), _vm._v("Rembrandt, "), _c('em', [_vm._v("Saint Jerome in a Dark Chamber")]), _vm._v(", 1642 ")])]), _vm._v(" "), _c('p', {
    staticClass: "C609"
  }, [_c('a', {
    attrs: {
      "href": "#/html/10_1_Socrat#id_253"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("5")]), _vm._v("Silhouette of Moses Mendelssohn, from Johann Caspar Lavater, "), _c('em', [_vm._v("Physiognomische Fragmente, zur Beförderung der Menschenkenntnis und Menschenliebe ")])])]), _vm._v(" "), _c('p', {
    staticClass: "C609"
  }, [_c('span', {
    attrs: {
      "href": "#/html/28_5_Moses#page_213",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "rr"
  }, [_vm._v("6")]), _vm._v("Michelangelo, "), _c('em', [_vm._v("Moses")]), _vm._v(", 1513–15 ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-391aa221","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/06_List_of.vue
// module id = 69
// module chunks = 0